import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
    return {
        pluginPath: state.appSettings.pluginPath
    }
}

class Logo extends React.Component {
    render() {
        return <Link to={"/"}>
            <img className="main-logo" src={this.props.pluginPath + "/assets/MainLogo.png"} />
        </Link>;
    }
}

export default connect(mapStateToProps)(Logo);